import React from "react";
import { apolloClient } from "../../..";
import { notify } from "../../Notify/Notify";
import UseAnimations from "react-useanimations";
import loadingIcon from "react-useanimations/lib/loading";
import ActivityFilters from "./ActivityFilters/ActivityFilters";
import DayWiseActivities from "./DayWiseActivities/DayWiseActivities";
import { getDate } from "../../../common/DateUtils";
import emptyActivityImage from "../../../assets/EmptyStates/empty_activity.svg";
import EmptyStates from "../../EmptyStates/EmptyStates";
import { FETCH_ACTIVITIES_QUERY, MARK_ACTIVITIES_READ } from "./Queries";

// Styles
import "./Activities.scss";

const ACTICITY_PAGE_SIZE = 50;

export const markActivitiesAsRead = async ({
  markAll = false,
  feedIds = [],
}) => {
  const variables = {
    markAll: markAll,
    feedIds: feedIds,
  };
  try {
    const result = await apolloClient.mutate({
      mutation: MARK_ACTIVITIES_READ,
      variables: variables,
    });
    return result;
  } catch (e) {
    const title = "Error";
    const detail = "oops! Something went wrong";
    const type = "error";
    notify(title, detail, type);
  }
};

const Activities = ({ handleDocumentView, currentUserInfo }) => {
  const [activities, setActivities] = React.useState({});
  const [newActivitiesCount, setNewActivitiesCount] = React.useState(0);
  const [isLoading, setIsLoading] = React.useState(true);
  const [isApiPending, setIsApiPending] = React.useState(true);

  const [activityPage, setActivityPage] = React.useState({
    currPage: 1,
    wasLastList: false,
    filterString: "",
    searchString: "",
  });

  const [isAllActivityRead, setIsActivityRead] = React.useState(false);

  // Refs
  const listInnerRef = React.useRef();

  const markAllActivitiesAsRead = async () => {
    const result = await markActivitiesAsRead({ markAll: true });
    if (result.data.markAsRead.success) {
      setNewActivitiesCount(0);
      setIsActivityRead(true);
    }
  };

  React.useEffect(() => {
    const { wasLastList, currPage, filterString, searchString } = activityPage;

    if (!wasLastList) {
      setIsLoading(true);
      setIsApiPending(true);
      const variables = {
        first: ACTICITY_PAGE_SIZE,
        skip: (currPage - 1) * ACTICITY_PAGE_SIZE,
        filterString: filterString,
        searchString: searchString,
      };
      apolloClient
        .query({
          query: FETCH_ACTIVITIES_QUERY,
          variables: variables,
        })
        .then((result) => {
          setIsApiPending(false);
          const { userFeed, unreadCount } = result.data.userFeedRecords;
          setNewActivitiesCount(unreadCount);
          if (userFeed.length !== ACTICITY_PAGE_SIZE) {
            setIsLoading(false);
          }
          if (userFeed.length === 0) {
            setActivityPage((activityPage) => {
              return { ...activityPage, wasLastList: true };
            });
            return;
          }

          setActivities((activities) => {
            const dayWiseActivities = currPage === 1 ? {} : { ...activities };
            userFeed.forEach((feed) => {
              const { createdTs } = feed;
              const date = getDate(createdTs, "yyyy-mm-dd");
              if (!dayWiseActivities[date]) {
                dayWiseActivities[date] = [];
              }
              dayWiseActivities[date].push(feed);
            });

            return dayWiseActivities;
          });
        })
        .catch((e) => {
          setIsApiPending(false);
          setIsLoading(false);
          const title = "Error";
          const detail = "oops! Something went wrong";
          const type = "error";
          notify(title, detail, type);
        });
    }
  }, [activityPage]);

  const onScroll = () => {
    if (listInnerRef.current && !isApiPending) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
      console.log(
        "Scroll trigger current",
        {
          scrollTop,
          scrollHeight,
          clientHeight,
        },
        scrollTop + clientHeight,
        scrollTop + clientHeight === scrollHeight
      );
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        setActivityPage((activityPage) => {
          return {
            ...activityPage,
            currPage: activityPage.currPage + 1,
          };
        });
      }
    }
  };

  const { currPage, wasLastList, filterString, searchString } = activityPage;

  return (
    <div className="activities">
      <div className="header">
        <h5>Activity</h5>
        {newActivitiesCount > 0 ? (
          <div className="header-new-count">{newActivitiesCount} New</div>
        ) : null}
      </div>
      <div className="body">
        <ActivityFilters
          {...{
            activityPage,
            setActivityPage,
            isEmpty:
              currPage === 1 &&
              wasLastList &&
              filterString === "" &&
              searchString === "",
            markAllActivitiesAsRead,
            setActivities,
          }}
        />

        <div className="activities-list" onScroll={onScroll} ref={listInnerRef}>
          {currPage === 1 && wasLastList ? (
            <div className="empty-state-container">
              <EmptyStates
                imgSrc={emptyActivityImage}
                emptyStateTitle="No activity yet !"
                emptyStateButtons={[]}
              />
            </div>
          ) : (
            Object.keys(activities).map((activityDayKey) => (
              <DayWiseActivities
                activities={activities[activityDayKey]}
                date={activityDayKey}
                key={activityDayKey}
                handleDocumentView={handleDocumentView}
                currentUserInfo={currentUserInfo}
                isAllActivityRead={isAllActivityRead}
                setNewActivitiesCount={setNewActivitiesCount}
              />
            ))
          )}
          {isLoading ? (
            <div className="loading-state-container">
              <UseAnimations
                className="loading-icon"
                animation={loadingIcon}
                autoplay={true}
                loop={true}
                strokeColor="Black"
                size={40}
              />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Activities;
